module.exports = __webpack_public_path__ + "static/media/diamond.8daf7abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/diamond.png
// module id = 122
// module chunks = 0